import env from "react-dotenv";

// Event photos live in our storage exactly as uploaded, often as multi-megabyte
// PNGs. Pages ask the API for a copy at the width they show (GET /api/img);
// anything else, like images bundled with the app, is used as it is.
const PHOTO_HOST = "pub-0b73f47acadc4e11b54be820f711e2aa.r2.dev";

const isStoredPhoto = (src) => {
  try {
    return new URL(src).host === PHOTO_HOST;
  } catch (error) {
    return false;
  }
};

export const photoUrl = (src, width) => {
  if (!src || !env?.API_URL || !isStoredPhoto(src)) return src;
  return `${env.API_URL}/img?src=${encodeURIComponent(src)}&w=${width}`;
};

// For <img srcSet>: the browser picks the smallest copy that is sharp enough
export const photoSrcSet = (src, widths) => {
  if (!src || !env?.API_URL || !isStoredPhoto(src)) return undefined;
  return widths.map((width) => `${photoUrl(src, width)} ${width}w`).join(", ");
};
